var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5996_1381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6257 0L12.7194 0.0468413C12.7416 0.00739599 12.7786 0.0172573 12.8131 0.0468413C12.8452 0.0123267 12.8772 0.0123267 12.9068 0.0468413C15.3658 -0.0714946 17.8198 1.102 19.6671 2.66995C21.8424 4.51402 23.6182 7.36887 23.9141 10.2385C24.0794 11.8385 24.0325 13.7713 23.5861 15.3146C22.4343 19.2961 19.2133 22.4715 15.2301 23.6055C13.7355 24.032 11.7896 24.074 10.2432 23.9088C5.68539 23.4231 1.43588 19.5304 0.281627 15.1421C0.0892518 14.4099 -0.00446935 13.6555 0.0497902 12.8986C0.0152614 12.869 0.0152614 12.837 0.0497902 12.8049C0.00786238 12.7852 0.0201941 12.7482 0.0497902 12.7112C0.0300595 12.6989 0.0152614 12.6693 0.00292969 12.6176V11.3085L0.0497902 11.168C0.0152614 11.131 0.0127951 11.0644 0.0497902 11.0274C-0.0957241 7.9926 1.68991 5.01695 3.89236 3.02496C5.79884 1.29923 8.4181 -0.0640986 11.0349 0.0468413C11.0645 0.0123267 11.0965 0.0123267 11.1286 0.0468413C11.1483 0.00493066 11.1853 0.0172573 11.2223 0.0468413C11.2347 0.0271186 11.2643 0.0123267 11.3161 0H12.6257ZM9.77459 17.4348C9.97929 17.4324 10.1569 17.319 10.3098 17.2006C10.5293 17.0305 11.7156 15.7337 11.8463 15.7559L14.838 17.9575C15.4003 18.2484 15.7185 18.0709 15.8665 17.4743L17.8494 8.14299C17.9555 7.5094 17.6891 7.09276 17.0207 7.27026C13.2817 8.84068 9.37257 10.0536 5.64593 11.6512C5.16499 11.8582 4.39302 12.2478 5.29817 12.6299C6.20332 13.012 7.30578 13.1698 8.21832 13.547H8.33424C10.6625 12.0851 12.971 10.5886 15.3239 9.17103L15.6174 9.16117L15.5434 9.39291L10.0311 14.3532L9.95956 14.6071L9.77212 17.4348H9.77459Z",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0468605 11.1718C0.0345288 11.2137 0.0172644 11.2112 0 11.1718V11.0312H0.0468605C0.0468605 11.0781 0.0468605 11.1249 0.0468605 11.1718Z",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 11.3124V11.1719H0.0468606C0.0443942 11.2236 0.0616586 11.2902 0 11.3124Z",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1279 0C11.1698 0.0123267 11.1674 0.029584 11.1279 0.0468413C11.0958 0.0468413 11.0662 0.0468413 11.0342 0.0468413V0H11.1279Z",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2217 0C11.2636 0.0123267 11.2611 0.029584 11.2217 0.0468413C11.1921 0.0493066 11.16 0.0468413 11.1279 0.0468413V0H11.2217Z",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3154 0C11.3031 0.044376 11.2611 0.044376 11.2217 0.0468413V0H11.3154Z",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7187 0C12.7606 0.0123267 12.7582 0.029584 12.7187 0.0468413C12.6793 0.044376 12.6398 0.0468413 12.625 0H12.7187Z",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8125 0C12.8544 0.0123267 12.8519 0.029584 12.8125 0.0468413C12.7804 0.0468413 12.7508 0.0493066 12.7188 0.0468413V0H12.8125Z",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9062 0V0.0468413C12.8742 0.0468413 12.8446 0.0468413 12.8125 0.0468413V0H12.9062Z",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0468605 12.7148C0.0345288 12.7567 0.0172644 12.7542 0 12.7148V12.6211C0.0468605 12.6334 0.0419279 12.6753 0.0468605 12.7148Z",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0468606 12.8085C0.0345288 12.8504 0.0172644 12.848 0 12.8085V12.7148H0.0468606C0.0493269 12.7444 0.0468606 12.7765 0.0468606 12.8085Z",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0468605 12.9023H0V12.8086H0.0468605C0.0468605 12.8406 0.0468605 12.8702 0.0468605 12.9023Z",
    fill: "#707070"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5996_1381"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/_telegram.2986715ef3d7b7d2e7823b8b5c8e10ce.svg";
export { ForwardRef as ReactComponent };